import { createSingletonMixin } from '@descope/sdk-helpers';

const CONTENT_ROOT_ID = 'content-root';
const ROOT_ID = 'root';
const initElementMixin = createSingletonMixin((superclass) => class InitElementMixinClass extends superclass {
    constructor(...rest) {
        var _a, _b;
        super(...rest);
        this.attachShadow({ mode: 'open' }).innerHTML = `

          <style>
            #${ROOT_ID}, #${CONTENT_ROOT_ID} {
              height: 100%;
            }
            #${ROOT_ID} {
              position: relative;
              height: fit-content;
            }
          </style>
          <div id="${ROOT_ID}">
            <div id="${CONTENT_ROOT_ID}"></div>
          </div>
          `;
        this.contentRootElement =
            (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(CONTENT_ROOT_ID);
        this.rootElement = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.getElementById(ROOT_ID);
    }
});

export { initElementMixin };
//# sourceMappingURL=initElementMixin.js.map
